import React from "react";
import { ArrowRight, Phone } from "lucide-react";
import { siteData } from "../mock";

export default function CTASection() {
  return (
    <section className="container-tight py-24">
      <div className="relative rounded-3xl overflow-hidden bg-gradient-to-br from-[#f0e4d5] to-[#e8825a]/30 p-10 md:p-16">
        <div className="absolute top-0 right-0 w-64 h-64 bg-[#d97757]/15 rounded-full blur-3xl" />
        <div className="absolute bottom-0 left-0 w-64 h-64 bg-[#d97757]/10 rounded-full blur-3xl" />
        <div className="relative max-w-2xl">
          <span className="chip mb-6">Réservez votre bilan gratuit</span>
          <h2 className="font-serif text-4xl md:text-5xl font-medium text-[#1a1815] leading-[1.1] tracking-tight">
            Prêt à retrouver mobilité et bien-être ?
          </h2>
          <p className="mt-5 text-lg text-[#4a4642] leading-relaxed">
            Première rencontre offerte pour définir ensemble un accompagnement adapté à votre corps et vos objectifs.
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <a
              href="https://www.resalib.fr/praticien/120570-jean-christophe-happillon-fasciatherapeute-quint-fonsegrives"
              target="_blank"
              rel="noreferrer"
              className="btn-primary"
            >
              Réserver maintenant <ArrowRight size={16} />
            </a>
            <a href={`tel:${siteData.practitioner.phone.replace(/\s/g, "")}`} className="btn-outline">
              <Phone size={16} /> {siteData.practitioner.phone}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
